module.exports = __webpack_public_path__ + "img/jq.0c002e28.png";